import request from './request.js';
import {requestbody} from './request.js'

export async function monitorpage(params = {

}) {
    return await requestbody('monitoringSummary/pageMonitor ', 'post', params)
}

export async function monitorCompanygetOne(params = {

}) {
    return await requestbody('/managementEx/monitorCompany/getOne', 'post', params)
}

export async function monitorUsergetOne(params = {

}) {
    return await requestbody('/managementEx/monitorUser/getOne', 'post', params)
}

export async function qualifications(params = {

}) {
    return await requestbody('/report/query/qualifications', 'post', params)
}

export async function querycomapny(params = {

}) {
    return await requestbody('/report/query/comapny', 'post', params)
}

export async function sumcomapny(params = {

}) {
    return await requestbody('/report/sum/comapny', 'post', params)
}
export async function taxcomapny(params = {

}) {
    return await requestbody('/report/tax/comapny', 'post', params)
}

export async function taxDifference(params = {

}) {
    return await requestbody('/report/fetch/taxDifference', 'post', params)
}
export async function sum(params = {

}) {
    return await request('report/show/sum', 'post', params)
}
export async function save_sum(params = {

}) {
    return await requestbody('/report/save/sum', 'post', params)
}
export async function companyaptitudepage(params = {

}) {
    return await request('/company-aptitude-config/page', 'get', params)
}
export async function sapsubjectcodespage(params = {

}) {
    return await request('/sap-subject-codes/page', 'get', params)
}
export async function aptitudeConfigsave(params = {

}) {
    return await requestbody('/aptitudeConfig/save', 'post', params)
}
